
    import {
        defineComponent, PropType,
    } from 'vue';
    import CheckBoxInputListWithOneSelect from '@ve/components/inputs/CheckBoxInputListWithOneSelect.vue';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import FilterListItem from '@ve/components/searchFilters/filterList/desktop/FilterListItem.vue';
    import { HotelCategoryForFilter } from '@ve/components/filters/hotelCategoriesFilter/common/types';
    import TextCommon from '@ve/components/inputs/TextCommon.vue';

    import FilterStars from '../common/FilterStars.vue';
    import useHotelCategoriesFilterList from '../common/useHotelCategoriesFilterList';

    export default defineComponent({
        name: 'hotel-categories-filter-list',
        components: {
            CheckBoxInputListWithOneSelect,
            CheckBoxInput,
            FilterStars,
            FilterListItem,
            TextCommon,
        },
        props: {
            categoriesList: {
                required: true,
                type: Array as PropType<HotelCategoryForFilter[]>,
            },
        },
        setup(props, ctx) {
            return useHotelCategoriesFilterList(ctx);
        },
    });
